import { ArgumentOutOfRangeException } from "../../shared/index.js";
import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const rangeAsync = (start, count) => {
    if (start < 0 || (start + count - 1) > Number.MAX_SAFE_INTEGER) {
        throw new ArgumentOutOfRangeException("start");
    }
    async function* iterator() {
        const max = start + count;
        for (let i = start; i < max; i++) {
            yield i;
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
